var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/counter/counter.tsx";
import React from 'react';
import { shortNumberFormat } from 'soapbox/utils/numbers';
/** A simple counter for notifications, etc. */
const Counter = ({
  count
}) => {
  return /*#__PURE__*/React.createElement("span", {
    className: "block px-1.5 py-0.5 bg-accent-500 text-xs text-white rounded-full ring-2 ring-white dark:ring-slate-800",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, shortNumberFormat(count));
};
export default Counter;